import { render, staticRenderFns } from "./dialogEspecialidade.vue?vue&type=template&id=028cc660&scoped=true"
import script from "./dialogEspecialidade.vue?vue&type=script&lang=js"
export * from "./dialogEspecialidade.vue?vue&type=script&lang=js"
import style0 from "./dialogEspecialidade.vue?vue&type=style&index=0&id=028cc660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028cc660",
  null
  
)

export default component.exports